import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';
import { Nullable } from '../Shared/Types';
import { DeviceStatus } from './ServicesAustraliaModels';

export const registerDevice = (createPayload: RegisterDeviceContracts.Request.CreateDevice) =>
    getExecutor(getConfig().apiEndpoints.servicesAustralia).post<
        RegisterDeviceContracts.Request.CreateDevice,
        RegisterDeviceContracts.Response.DeviceCreateResult
    >(`api/v1/devices/register`, createPayload);

export namespace RegisterDeviceContracts {
    export namespace Request {
        export interface CreateDevice {
            customer: Nullable<{
                name?: string;
                authoringSystem: string;
                authoringSystemForeignKey: string;
            }>;
            applicationClientIdentifier: string;
            authoringSystem: string;
            authoringSystemForeignKey: string;
            prodaActivationCode: string;
            prodaDeviceName: string;
            prodaOrganisationIdentifier: string;
            instanceQueueName: string;
            prodaClientIdentifier: string;
            applicationName: string;
        }
    }

    export namespace Response {
        export interface DeviceCreateResult {
            authoringSystem: string;
            authoringSystemForeignKey: string;
            status: DeviceStatus;
            errors: RegisterDeviceResponseDeviceError[];
        }

        interface RegisterDeviceResponseDeviceError {
            code: string;
            message: string;
        }
    }
}
